import { render, staticRenderFns } from "./PosturasByIdLoteItem.vue?vue&type=template&id=65efe234"
import script from "./PosturasByIdLoteItem.vue?vue&type=script&lang=js"
export * from "./PosturasByIdLoteItem.vue?vue&type=script&lang=js"
import style0 from "./PosturasByIdLoteItem.vue?vue&type=style&index=0&id=65efe234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports